import React from "react"
import "./FacilityCard.scss"
import FontAwesome from "react-fontawesome"
import PropTypes from "prop-types"
import GridViewCard from "../GridViewCard"
import { maybePluralize } from "../../helpers/sharedHelperFunctions"

const FacilityCard = props => {
  return (
    <div className="FacilityCard">
      <GridViewCard
        name={props.name}
        compliance={props.compliance}
        opportunities={props.opportunities}
        picture={true}
      >
        <div>
          <FontAwesome name="users" />
          {maybePluralize(props.departmentCount, "Department")}
        </div>
        <div className="detail-with-svg">
          <div className="units-icon" />
          {maybePluralize(props.unitCount, "Unit")}
        </div>
      </GridViewCard>
    </div>
  )
}

FacilityCard.propTypes = {
  name: PropTypes.string.isRequired,
  compliance: PropTypes.number,
  opportunities: PropTypes.number,
  departmentCount: PropTypes.number,
  unitCount: PropTypes.number,
}

FacilityCard.defaultProps = {
  compliance: 0,
  opportunities: 0,
  departmentCount: 0,
  unitCount: 0,
}

export default FacilityCard
